module.exports = __webpack_public_path__ + "img/2_b.80437fc8.jpg";